// extracted by mini-css-extract-plugin
export default {"invoiceInfoBlock":"P8sDXQUNdqP8NWX+oPY5UQ=="};